/**
 * AMCRFM ユーザーランク
 */
const USER_RANK = {
  1: '1.優良',
  2: '2.F2-',
  3: '3.F1',
  4: '4.優良_休眠注意',
  5: '5.F2-_休眠注意',
  6: '6.F1_休眠注意',
  7: '7.優良_休眠',
  8: '8.F2-_休眠',
  9: '9.F1_休眠'
}

export default USER_RANK
